// Arabisch (ar), kioskBoard: zelfde vorm als kioskBoard.nl.ts. Eenvoudig Standaardarabisch voor
// kinderen; namen blijven in hun eigen schrift, cijfers Latijns (de cijferkeuze doet de rest).
export const kioskBoardAr = {
    // Agenda
    weekToggle: 'الأسبوع',
    weekTitle: 'الأسبوع {week}',
    weekTitleToday: 'اليوم - الأسبوع {week}',
    backToToday: 'اليوم',
    menu: 'المزيد',
    menuMake: 'إنشاء',
    menuHome: 'المنزل',
    menuBoard: 'اللوحة',
    boardRefreshing: 'جارٍ التحديث…',
    boardLoading: 'جارٍ التحميل…',
    boardRefreshFailed: 'تعذّر التحديث: لا يوجد اتصال. تعرض اللوحة آخر البيانات المعروفة.',
    pageOf: 'الصفحة {n} من {total}',
    prevWeek: 'الأسبوع السابق',
    nextWeek: 'الأسبوع القادم',
    weekEmpty: 'هذا الأسبوع فارغ حتى الآن',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'يوم',
    modeWeek: 'أسبوع',
    agendaMode: 'العرض',
    prevDay: 'اليوم السابق',
    nextDay: 'اليوم التالي',
    filterPeople: 'عرض لـ',
    noEventsWeek: 'لا مواعيد هذا الأسبوع',
    noEventsDay: 'لا مواعيد في هذا اليوم',
    noEventsFor: 'لا شيء مخطط لـ {names}',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'شهر',
    prevMonth: 'الشهر السابق',
    nextMonth: 'الشهر التالي',
    noEventsMonth: 'لا مواعيد هذا الشهر',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'وقت الطريق',
    rideBring: 'توصيل',
    rideFetch: 'إحضار',
    rideOnTheWay: 'في الطريق',
    rideBack: 'العودة',
    moreItems: '+{count}',
    laterAt: 'بعد قليل · {time}',
    nowUntil: 'الآن · حتى {time}',
    scrollMore: 'مواعيد أخرى',
    tasksMore: 'مهام أخرى',
    tasksLess: 'العودة إلى الأعلى',
    departClose: 'إغلاق التنبيه',
    departWho: '{names}: الخروج الساعة {time} إلى {title}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} يوصل',
    ridePickup: '{name} يُحضر',
    and: 'و',
    travel: '{minutes} دقيقة في الطريق',
    leaveAt: 'الخروج الساعة {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'في البيت الساعة {time}',
    conflict: 'في نفس وقت شيء آخر',
    continues: 'مستمر',
    tomorrowFirst: 'غدًا {time}: {title}',
    // Taken
    waitingApproval: 'ننتظر بابا أو ماما',
    klaarApproval: 'سيتحقق منها بابا أو ماما.',
    doneBy: 'الأول: {name}',
    claimedBy: 'يقوم بها: {name}',
    tryAgain: 'مرة أخرى؟',
    notSaved: 'لم ينجح ذلك',
    cloudPending: 'جارٍ الحفظ…',
    memberRail: 'أفراد العائلة',
    pointsReserved: '{count} محجوزة',
    // Beloningen
    rewardsTile: 'المكافآت',
    rewardsOf: 'مكافآت {name}',
    goal: 'الهدف: {name}',
    goalProgress: '{value} من {max}',
    goalHint: 'اختاروا معًا هدفًا للادخار',
    rewardCanGet: 'ممكن!',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'متاح',
    rewardMissing: 'باقي {count}',
    rewardWaiting: 'ننتظر بابا أو ماما',
    rewardBusy: 'الأخرى أولًا',
    rewardLimit: 'غدًا مرة أخرى',
    rewardSoldOut: 'نفدت',
    rewardCancel: 'إلغاء',
    whoAreYou: 'من أنت؟',
    requestQuestion: 'هل تريد {reward}؟',
    cancelQuestion: 'إلغاء {reward}؟',
    keepIt: 'لا، أبقِها',
    cancelYes: 'نعم، ألغِها',
    notYou: 'لست أنت؟',
    // Wie vinkt af?
    areYou: 'هل أنت {name}؟',
    yesMe: 'نعم، هذا أنا',
    notMe: 'لا',
    // Wie ben jij?
    notYours: 'هذا يخص {name}',
    notYoursBody: 'انظر، هذه قائمتك.',
    closeRewards: 'العودة إلى اليوم',
    // Detail, nacht, rust
    detailClose: 'إغلاق',
    detailEdit: 'تعديل',
    sleepWell: 'تصبحون على خير',
    tomorrowAt: 'غدًا الساعة {time}: {title}',
    calmDown: 'على مهلك…',
    upcoming: 'قريبًا',
    tomorrowEmpty: 'لا شيء مخطط بعد',
    inDays: {
        zero: 'اليوم',
        one: 'بعد يوم واحد',
        two: 'بعد يومين',
        few: 'بعد {count} أيام',
        many: 'بعد {count} يومًا',
        other: 'بعد {count} يوم',
    },
};
//# sourceMappingURL=kioskBoard.ar.js.map